<template>
  <div>
    <div
      :class="fileInputTargetClass"
      style="font-size: 15px !important;"
    ></div>

    <div :class="progressBarTargetClass"></div>

    <!-- Uploaded files list -->
    <div v-show="showUploadedFiles" class="uploaded-files mt-4">
      <h5>Uploaded files:</h5>
      <ol></ol>
    </div>
  </div>
</template>

<script>
import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
import FileInput from "@uppy/file-input";
import ProgressBar from "@uppy/progress-bar";
import { v4 as uuidv4 } from "uuid";

import "@uppy/core/dist/style.css";
import "@uppy/file-input/dist/style.css";
import "@uppy/progress-bar/dist/style.css";

export default {
  name: "UppyXHRFileUploader",
  props: {
    title: {
      type: String,
      default: "Choose Files",
    },
    url: {
      type: String,
      required: true,
    },
    maxFiles: {
      type: Number,
      default: null,
    },
    fileTypes: {
      type: Array,
      default: null,
    },
    meta: {
      type: Object,
      default: () => {
        return {};
      },
    },
    headers: {
      type: Object,
      default: () => {
        return {};
      },
    },
    bgColor: {
      type: String,
      default: "#FFFCF1",
    },
    dashboardHeight: {
      type: String,
      default: "100% !important",
    },
  },
  data() {
    return {
      uppy: null,
      showUploadedFiles: false,
    };
  },
  computed: {
    uppyId() {
      return uuidv4();
    },
    fileInputTargetClass() {
      return `Uppy-${this.uppyId}`;
    },
    progressBarTargetClass() {
      return `UppyProgressBar-${this.uppyId}`;
    },
    uploadedFilesTargetClass() {
      return `uploaded-files-${this.uppyId}`;
    },

    acceptFiles() {
      if (!this.fileTypes || this.fileTypes.length === 0) {
        return null;
      }
      return this.fileTypes.toString();
    },
    hasFiles() {
      if (!this.uppy) {
        return false;
      }
      return !!this.uppy.getFiles().length;
    },
    canUploadFiles() {
      if (!this.maxFiles || !this.hasFiles) {
        return true;
      }
      return this.uppy.getFiles().length < this.maxFiles;
    },
  },

  mounted() {
    this.uppy = new Uppy({
      id: this.uppyId,
      autoProceed: true,
      allowMultipleUploadBatches: true,
      restrictions: {
        maxNumberOfFiles: this.maxFiles,
        allowedFileTypes: this.fileTypes,
      },
      meta: this.meta,
    });
    this.uppy.use(FileInput, {
      target: "." + this.fileInputTargetClass,
      locale: {
        strings: {
          //   chooseFiles: "Choose Sample File (Optional)",
          chooseFiles: this.title,
        },
      },
    });
    this.uppy.use(ProgressBar, {
      target: "." + this.progressBarTargetClass,
      hideAfterFinish: false,
    });
    this.uppy.use(XHRUpload, {
      endpoint: this.url,
      formData: true,
      fieldName: "file",
      headers: this.headers,
    });

    this.uppy
      .on("upload-success", (file, response) => {
        this.$emit("uploaded", file, response);

        // And display uploaded files
        this.showUploadedFiles = true;
        const li = document.createElement("li");
        const fileName = file.name;
        // const url = response.uploadURL;
        // const a = document.createElement("a");
        // a.href = url;
        // a.target = "_blank";
        // a.appendChild(document.createTextNode(fileName));
        // li.appendChild(a);
        li.appendChild(document.createTextNode(fileName));

        document.querySelector(".uploaded-files ol").appendChild(li);
      })
      .on("file-removed", (file) => {
        this.$emit("removed", file);
      })
      .on("upload", () => {
        this.$emit("upload", true);
      })
      .on("complete", () => {
        this.$emit("complete", true);
      });
  },
};
</script>

<style lang="css">
.uppy-FileInput-btn {
  font-size: 15px !important;
}
.uploaded-files ol li {
  padding: 0.25rem !important;
  font-size: 15px;
}
</style>
